/** [English, Hindi] pairs for /staff/items/batch. */
export const batchMessages = {
  'ops.batch.title': ['Batch item edit', 'थोक वस्तु संपादन'],
  'ops.batch.subtitle': ['Change or delete many items at once. You always see a preview before anything is saved.', 'कई वस्तुएँ एक साथ बदलें या हटाएँ। कुछ भी सहेजने से पहले पूर्वावलोकन दिखता है।'],
  'ops.batch.step1': ['1. Choose items', '1. वस्तुएँ चुनें'],
  'ops.batch.step1Hint': ['Paste barcodes or search and tick rows.', 'बारकोड चिपकाएँ या खोजकर पंक्तियाँ चुनें।'],
  'ops.batch.step2': ['2. Choose what to do', '2. क्या करना है चुनें'],
  'ops.batch.step2Hint': ['Tick the fields to change. Fields you leave unticked are not touched.', 'बदलने वाले फ़ील्ड चुनें। बिना चुने फ़ील्ड नहीं बदलेंगे।'],
  'ops.batch.step2Delete': ['Deleted items disappear from the catalogue. Items on loan, in transit or on hold are skipped.', 'हटाई गई वस्तुएँ सूची से गायब हो जाती हैं। ऋण, मार्ग या होल्ड वाली वस्तुएँ छोड़ दी जाती हैं।'],
  'ops.batch.mode': ['Batch action', 'बैच क्रिया'],
  'ops.batch.modify': ['Modify', 'बदलें'],
  'ops.batch.delete': ['Delete', 'हटाएँ'],
  'ops.batch.deleteTitle': ['Delete is destructive', 'हटाना अपरिवर्तनीय है'],
  'ops.batch.deleteBody': ['You will see which items can be deleted before anything happens, then confirm by typing the count.', 'कुछ होने से पहले आप देखेंगे कि कौन-सी वस्तुएँ हट सकती हैं, फिर संख्या टाइप करके पुष्टि करेंगे।'],
  'ops.batch.choose': ['Choose...', 'चुनें...'],
  'ops.batch.clearValue': ['(clear this value)', '(यह मान हटाएँ)'],
  'ops.batch.needItems': ['Choose items to continue.', 'आगे बढ़ने के लिए वस्तुएँ चुनें।'],
  'ops.batch.needChanges': ['Tick at least one field to change.', 'बदलने के लिए कम से कम एक फ़ील्ड चुनें।'],
  'ops.batch.preview': ['Preview changes', 'बदलाव देखें'],
  'ops.batch.group.where': ['Where it lives', 'यह कहाँ है'],
  'ops.batch.group.describe': ['Description', 'विवरण'],
  'ops.batch.group.circulation': ['Circulation', 'परिसंचरण'],
  'ops.batch.group.acquisition': ['Acquisition', 'अधिग्रहण'],
  'ops.batch.group.state': ['State', 'स्थिति'],
  'ops.field.homeLibraryId': ['Home library', 'गृह पुस्तकालय'],
  'ops.field.holdingLibraryId': ['Holding library', 'धारक पुस्तकालय'],
  'ops.field.locationId': ['Shelving location', 'शेल्फ स्थान'],
  'ops.field.collectionId': ['Collection', 'संग्रह'],
  'ops.field.itemTypeId': ['Item type', 'वस्तु प्रकार'],
  'ops.field.classificationSourceId': ['Classification source', 'वर्गीकरण स्रोत'],
  'ops.field.callNumber': ['Call number', 'कॉल नंबर'],
  'ops.field.publicNote': ['Public note', 'सार्वजनिक टिप्पणी'],
  'ops.field.staffNote': ['Staff note', 'कर्मचारी टिप्पणी'],
  'ops.field.notForLoan': ['Not for loan status', 'ऋण के लिए नहीं स्थिति'],
  'ops.field.restricted': ['Restricted', 'प्रतिबंधित'],
  'ops.field.price': ['Price', 'मूल्य'],
  'ops.field.replacementPrice': ['Replacement price', 'प्रतिस्थापन मूल्य'],
  'ops.field.source': ['Source', 'स्रोत'],
  'ops.field.dateAccepted': ['Date accepted', 'स्वीकृति तिथि'],
  'ops.field.withdrawn': ['Withdrawn', 'हटाई गई'],
  'ops.field.damaged': ['Damaged', 'क्षतिग्रस्त'],
  'ops.field.lost': ['Lost status', 'खोया स्थिति'],
  'ops.fieldError.REQUIRED': ['Choose or enter a value.', 'मान चुनें या दर्ज करें।'],
  'ops.fieldError.INVALID_NUMBER': ['Enter a number.', 'संख्या दर्ज करें।'],
  'ops.fieldError.NEGATIVE': ['Must not be negative.', 'ऋणात्मक नहीं हो सकता।'],
  'ops.fieldError.INVALID_DATE': ['Use the format YYYY-MM-DD.', 'YYYY-MM-DD प्रारूप उपयोग करें।'],
  'ops.preview.title': ['Preview', 'पूर्वावलोकन'],
  'ops.preview.subtitle': ['Nothing has been saved yet.', 'अभी कुछ भी सहेजा नहीं गया है।'],
  'ops.preview.dryRun': ['Dry run', 'ड्राई रन'],
  'ops.preview.requested': ['Requested', 'अनुरोधित'],
  'ops.preview.toChange': ['Will change', 'बदलेंगी'],
  'ops.preview.toDelete': ['Will delete', 'हटेंगी'],
  'ops.preview.unchanged': ['Already correct', 'पहले से सही'],
  'ops.preview.skipped': ['Skipped', 'छोड़ी गईं'],
  'ops.preview.skippedTitle': ['{count} skipped', '{count} छोड़ी गईं'],
  'ops.preview.stale': ['You changed the selection or fields. Refresh the preview before applying.', 'आपने चयन या फ़ील्ड बदले। लागू करने से पहले पूर्वावलोकन ताज़ा करें।'],
  'ops.preview.refresh': ['Refresh preview', 'पूर्वावलोकन ताज़ा करें'],
  'ops.preview.willChange': ['{count} items will be changed.', '{count} वस्तुएँ बदली जाएँगी।'],
  'ops.preview.willDelete': ['{count} items will be deleted.', '{count} वस्तुएँ हटाई जाएँगी।'],
  'ops.preview.apply': ['Apply to {count} items', '{count} वस्तुओं पर लागू करें'],
  'ops.preview.applyDelete': ['Delete {count} items', '{count} वस्तुएँ हटाएँ'],
  'ops.preview.tableCaption': ['Changes per item', 'प्रति वस्तु बदलाव'],
  'ops.preview.action': ['Action', 'क्रिया'],
  'ops.preview.changes': ['Changes', 'बदलाव'],
  'ops.preview.deleteBadge': ['Delete', 'हटाएँ'],
  'ops.preview.more': ['and {count} more not shown', 'और {count} नहीं दिखाई गईं'],
  'ops.preview.nothing': ['Nothing would change: every item already has these values.', 'कुछ नहीं बदलेगा: हर वस्तु में ये मान पहले से हैं।'],
  'ops.warn.LARGE_BATCH': ['This is a large batch. Check the preview carefully.', 'यह बड़ा बैच है। पूर्वावलोकन ध्यान से जाँचें।'],
  'ops.warn.DELETE_DESTRUCTIVE': ['Deleting items cannot be undone from this screen.', 'इस स्क्रीन से वस्तुओं का हटाना पूर्ववत नहीं किया जा सकता।'],
  'ops.warn.MOVES_LIBRARY': ['This moves items to another library. Holds and transfers may be affected.', 'यह वस्तुओं को दूसरे पुस्तकालय में ले जाता है। होल्ड और स्थानांतरण प्रभावित हो सकते हैं।'],
  'ops.warn.WITHDRAW': ['Items will be withdrawn and no longer circulate.', 'वस्तुएँ हटा दी जाएँगी और परिसंचरण में नहीं रहेंगी।'],
  'ops.warn.MARK_LOST': ['Items will be marked lost.', 'वस्तुएँ खोई हुई चिह्नित होंगी।'],
  'ops.warn.SKIPPED_SOME': ['Some items were skipped.', 'कुछ वस्तुएँ छोड़ी गईं।'],
  'ops.warn.NOTHING_CHANGES': ['Nothing changes.', 'कुछ नहीं बदलता।'],
  'ops.confirm.modifyTitle': ['Apply changes to {count} items?', '{count} वस्तुओं पर बदलाव लागू करें?'],
  'ops.confirm.modifyBody': ['The changes shown in the preview will be saved.', 'पूर्वावलोकन में दिखे बदलाव सहेजे जाएँगे।'],
  'ops.confirm.modifyLabel': ['Apply to {count}', '{count} पर लागू करें'],
  'ops.confirm.largeBody': ['This changes {count} items. Type the number to confirm.', 'यह {count} वस्तुएँ बदलता है। पुष्टि के लिए संख्या टाइप करें।'],
  'ops.confirm.deleteTitle': ['Delete {count} items?', '{count} वस्तुएँ हटाएँ?'],
  'ops.confirm.deleteBody': ['The items disappear from the catalogue. Type the number of items to confirm.', 'वस्तुएँ सूची से गायब हो जाएँगी। पुष्टि के लिए वस्तुओं की संख्या टाइप करें।'],
  'ops.confirm.deleteLabel': ['Delete {count}', '{count} हटाएँ'],
  'ops.result.titleModify': ['Changes applied', 'बदलाव लागू'],
  'ops.result.titleDelete': ['Items deleted', 'वस्तुएँ हटाई गईं'],
  'ops.result.done': ['Done', 'पूर्ण'],
  'ops.result.changed': ['Changed', 'बदली गईं'],
  'ops.result.deleted': ['Deleted', 'हटाई गईं'],
  'ops.result.another': ['Start another batch', 'नया बैच शुरू करें'],
  'ops.result.toast': ['{count} items processed', '{count} वस्तुएँ संसाधित'],
} as const satisfies Record<string, readonly [string, string]>;
